// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RpzY","right":"styles_right__bHFg1"};